import React from 'react';

import Modal from './Modal';
import ReferralForm from './ReferralForm';

/*
 * We use this to add a Referral some time after client creation
Call this with
    <ReferralModal
        show={the condition under which it should show}
        viewingFirmId={firmId}
        caseId={caseId}
        clientId={id of client for whom the user wants to provide a late referral}
        successFunc={(newReferralId) => a function(newReferralId) for reporting the new referral and closing the dialog}
        closeModalFunc={a function for closing the dialog}
    />
*/

class ReferralModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { show, viewingFirmId, caseId, clientId, closeModalFunc } = this.props;
    return (
      <Modal open={show} hideButtons={true} onCancel={closeModalFunc}>
        <ReferralForm
          clientId={clientId}
          caseId={caseId}
          viewingFirmId={viewingFirmId}
          closeModalFunc={closeModalFunc}
        />
      </Modal>
    );
  }
}

export default ReferralModal;
